{
  "certificates": {
    "modal": {
      "labels": {
        "productionSite": "Production Site"
      }
    }
  },
  "columns": {
    "createdAt": "Created at",
    "lang": "Lang",
    "question": "Question",
    "updatedAt": "Updated at"
  },
  "customFields": {
    "add_enum_value": "New option",
    "constraints": {
      "enum": "List (select one)",
      "multi_enum": "List (select multiple)",
      "number": "Number",
      "string": "Text"
    },
    "create": "New collectible field",
    "enum_values": "Options",
    "labels": {
      "constraint": "Type",
      "csvColumnName": "Export",
      "documentRequirement": "Attachment",
      "ecobalyseField": "Mapping Ecobalyse",
      "ecobalyseFieldValue": "Mapping Ecobalyse",
      "fieldRequirement": "Requirement",
      "forActivity": "Collected for",
      "max": "Maximum",
      "message": "Helper",
      "min": "Minimum",
      "onActivity": "Collected on",
      "organization": "Organizations",
      "orginalText": "Label"
    },
    "placeholders": {
      "constraint": "number, list, text, etc.",
      "csvColumnName": "column name used in .csv export",
      "documentRequirement": "none, optional or required",
      "ecobalyseField": "select a matching Ecobalyse reference",
      "ecobalyseFieldValue": "select a matching Ecobalyse reference",
      "fieldRequirement": "optional or mandatory",
      "forActivity": "select an activity",
      "max": "999.9",
      "message": "write a guidance text",
      "min": "0.0",
      "onActivity": "select an activity",
      "organization": "select one or multiple organizations",
      "orginalText": "name the new collectible field"
    },
    "submit": "Save",
    "syncToProducts": {
      "cancel": "Cancel",
      "confirm": "Confirm",
      "confirmation": "This will sync all custom fields to products for the selected organization. Are you sure you want to continue?",
      "warning": "Warning"
    },
    "tooltips": {
      "constraint": "Defines the kind of data this field will collect (e.g., text, number, file). Choose the type that best fits the expected input.",
      "csvColumnName": "A unique identifier used when exporting data. This acts as the column name in data exports and integrations.",
      "documentRequirement": "Allows file uploads (e.g., images, certificates, documents) related to this field. Enable if supporting evidence or documentation is required.",
      "ecobalyseField": "Link this field to a corresponding variable or concept in the Ecobalyse framework, if applicable. Useful for environmental impact calculations.",
      "ecobalyseFieldValue": "Link this field to a corresponding variable or concept in the Ecobalyse framework, if applicable. Useful for environmental impact calculations.",
      "fieldRequirement": "Specify if this field is mandatory. Required fields must be filled out before submission.",
      "forActivity": "Indicates which production activity this data belongs to or is being collected for.",
      "max": "The upper limit of acceptable input values. Applies to numerical or count-based fields. Unlocks validate user entries.",
      "message": "Helper text or instructions shown near the field to guide users filling it in. Useful for clarifying expected formats or examples.",
      "min": "The lower limit of acceptable input values. Applies to numerical or count-based fields. Helps prevent underreporting.",
      "onActivity": "Indicates the specific production stage or process (e.g., spinning, assembly) where this data point should be captured.",
      "organization": "Restrict or assign this field to specific brand organizations. Useful when data should only be provided for certain actors.",
      "orginalText": "The name or title shown to users for this field. It should clearly describe what data is being requested."
    },
    "update": "Edit"
  },
  "faq": {
    "modal": {
      "create": {
        "success": "Question created!",
        "title": "New entry"
      },
      "edit": {
        "success": "Question updated!",
        "title": "Update entry"
      },
      "labels": {
        "answer": "Answer",
        "category": "Category",
        "lang": "Lang",
        "question": "Question"
      },
      "placeholders": {
        "answer": "Type a short answer",
        "category": "Select a category",
        "lang": "Select a language",
        "question": "Type your question"
      },
      "submit": "Save"
    }
  },
  "ingestion": {
    "retry": {
      "blank": "Retry blank import",
      "products": "Retry products import"
    }
  },
  "invoices": {
    "createButton": "New Invoice",
    "modal": {
      "labels": {
        "amount": "Amount",
        "issueDate": "issueDate",
        "reference": "Reference"
      },
      "placeholders": {
        "amount": "Type the invoice amount",
        "issueDate": "Select the invoice issue date",
        "reference": "Type the invoice reference"
      },
      "submit": "Save",
      "success": "Invoice created!",
      "title": "New Invoice"
    }
  },
  "mapping": {
    "modal": {
      "delete": {
        "areYouSureText": "Are you sure you want to delete the mapping for \"{{alias}}\" ({{label}})?",
        "cancelText": "Cancel",
        "confirmText": "Delete",
        "title": "Confirm Deletion"
      },
      "update": {
        "areYouSureText": "Are you sure you want to change \"{{alias}}\" from \"{{label}}\" to \"{{newLabel}}\"?",
        "cancelText": "Cancel",
        "confirmText": "Update",
        "title": "Confirm Mapping Change"
      }
    },
    "none": "None"
  },
  "materialTypes": {
    "sort": {
      "operationChainName": "Operation chain",
      "originalText": "Original text"
    }
  },
  "plan": {
    "agecProductPagePlan": {
      "advanced": " Product sheets search tool + unique link / QR code per product reference",
      "essential": "Product sheets search tool only",
      "label": "Access to product sheets",
      "starter": "No product sheets"
    },
    "certificatesPlan": {
      "advanced": "Disabled",
      "expert": "Enabled",
      "label": "Certificates plan"
    },
    "customFieldsPlan": {
      "advanced": "Disabled",
      "expert": "Enable",
      "label": "Custom data"
    },
    "lcaCustomizationPlan": {
      "advanced": "None",
      "expert": "Perform & show products LCA",
      "label": "Life cycle analysis"
    },
    "outputCustomizationPlan": {
      "advanced": "Customized design (logo + brand color)",
      "essential": "Standard",
      "expert": "Tailored",
      "label": "Communication materials"
    },
    "rduePlan": {
      "label": "EUDR",
      "no": "No",
      "yes": "Yes"
    },
    "zalandoPlan": {
      "label": "Zalando plan",
      "no": "No",
      "yes": "Yes"
    }
  },
  "prodSiteFieldDefs": {
    "columns": {
      "activitiesValue": "{{length}} activities",
      "enumValues": "{{length}} values"
    },
    "create": "New production site field",
    "labels": {
      "activities": "Activities",
      "allActivities": "All activities",
      "orginalText": "Label",
      "type": "Type"
    },
    "placeholders": {
      "activities": "Select activities",
      "orginalText": "The name or title shown to users for this field. It should clearly describe what data is being requested.",
      "type": "Defines the kind of data this field will collect (e.g., text, number, file). Choose the type that best fits the expected input."
    }
  },
  "productTypes": {
    "sort": {
      "operationChainName": "Operation chain",
      "originalText": "Original text"
    }
  },
  "standards": {
    "search": {
      "label": "Search"
    },
    "sort": {
      "certificateTypeCount": "Certificate type count",
      "id": "ID",
      "name": "Name"
    }
  },
  "tabs": {
    "certificatesTypes": "Standards & Certificates",
    "customFields": "Collectible Fields",
    "exports": "Exports",
    "faq": "FAQ",
    "general": "General",
    "ingestion": "Ingestion",
    "ingestionSettings": "Ingestion Settings",
    "invoices": "Invoices",
    "mapping": "Referentials",
    "masterLists": "Master Lists",
    "materialTypes": "Material Types",
    "organizations": "Organizations",
    "prodSiteFields": "Production Site Fields",
    "productTypes": "Product Category",
    "security": "Security",
    "translations": "Translations"
  },
  "title": "Back Office",
  "translations": {
    "search": {
      "label": "Search"
    }
  }
}
